"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentPageInvalidChildrenError = void 0;
class ContentPageInvalidChildrenError extends Error {
  constructor(invalidType) {
    super(`Invalid child type '${invalidType}' found. All children components of ContentPages must be of type ContentPage`);
  }
}
exports.ContentPageInvalidChildrenError = ContentPageInvalidChildrenError;